import { Link, useNavigate } from '@tanstack/react-router';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from 'src/components/ui/table';
import { Badge } from 'src/components/ui/badge';
import paths from 'src/paths';

interface AgentBuilderSummary {
  id: string;
  name: string;
  description?: string;
  toolCount: number;
  permissionCount: number;
  isActive: boolean;
}

const MOCK_AGENTS: AgentBuilderSummary[] = [
  {
    id: '1',
    name: 'Sales Assistant',
    description: 'Helps with customer inquiries and order processing',
    toolCount: 5,
    permissionCount: 8,
    isActive: true,
  },
  {
    id: '2',
    name: 'Inventory Manager',
    description: 'Manages stock levels and reorder points',
    toolCount: 3,
    permissionCount: 4,
    isActive: false,
  },
];

export function AgentBuilderDefinitionsTab() {
  const navigate = useNavigate();
  const agents = MOCK_AGENTS;

  if (agents.length === 0) {
    return (
      <div className="text-center py-12 text-muted-foreground">
        <p>No agents found.</p>
        <p className="text-sm mt-2">
          Create one using the button above to get started.
        </p>
      </div>
    );
  }

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Name</TableHead>
          <TableHead>Status</TableHead>
          <TableHead>Tools</TableHead>
          <TableHead>Permissions</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {agents.map((agent) => (
          <TableRow
            key={agent.id}
            className="cursor-pointer hover:bg-muted/50"
            onClick={() => {
              void navigate({
                to: paths.authenticated.agents.detail,
                params: { agentId: agent.id } as any,
              });
            }}
          >
            <TableCell>
              <Link
                to={paths.authenticated.agents.detail}
                params={{ agentId: agent.id } as any}
                className="font-medium hover:underline"
              >
                {agent.name}
              </Link>
              {agent.description && (
                <p className="text-sm text-muted-foreground mt-1">
                  {agent.description}
                </p>
              )}
            </TableCell>
            <TableCell>
              <Badge variant={agent.isActive ? 'default' : 'secondary'}>
                {agent.isActive ? 'Active' : 'Inactive'}
              </Badge>
            </TableCell>
            <TableCell>{agent.toolCount}</TableCell>
            <TableCell>{agent.permissionCount}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
